import { capitalize } from 'lodash';

const filter = (value): string => {
  if (!value) {
    return ''
  }

  return capitalize(value)
}

export default filter
